<script setup>
import { useReferenceWorkspace } from "./referenceWorkspace";
import ReferenceProgress from "@/components/ReferenceProgress.vue";

const { reference, setSectionRef } = useReferenceWorkspace();
</script>

<template>
  <section
    id="timeline"
    :ref="(el) => setSectionRef('timeline', el)"
    class="min-w-0 scroll-mt-24 2xl:col-span-12"
  >
    <div class="mb-3">
      <div
        class="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400"
      >
        Timeline
      </div>
      <h2 class="text-xl font-semibold text-slate-900 dark:text-slate-100">
        Status & Progress
      </h2>
    </div>
    <ReferenceProgress :reference="reference.data" />
  </section>
</template>
